export default "__VITE_ASSET__D0wtks2v__"